import styled from 'styled-components';
import { devices } from '../../utilities/responsive';

export const SearchForm = styled.form`
    display: flex;
    flex-wrap: nowrap;
    border: 1px solid var(--grey);
    padding: 1.3rem 1.5rem;
    border-radius: 0.7rem;
    background-color: #1A1D24;
    align-items: center;
    align-content: center;
    justify-content: space-between;
    margin-bottom: 12px;

    @media ${devices.tabletPortrait} {
        padding: 1rem 1.2rem;
    }

    .search-btn {
        background-color: var(--transparent);
        border: none;
        box-shadow: none;
        color: var(--transparent);

        svg {
            margin-top: 10px;
            transition: all 1s ease;
            height: 30px;
            width: 30px;

            @media ${devices.tabletPortrait} {
                height: 20px;
                width: 20px;
            }

            &:hover {
                cursor: pointer;
                height: 30px;
                width: 40px;

                @media ${devices.tabletPortrait} {
                    height: 20px;
                    width: 30px;
                }
            }
        }

        &:hover {
            cursor: pointer;
        }

        &:focus  {
            border: none;
            outline: none;
        }
    }
`

export const Input = styled.input`
    width: 100%;
    border: none;
    background-color: #1A1D24;
    color: var(--green);
    box-shadow: none;
    outline: none;
    font-size: 22px;
    font-weight: 400;
    font-family: 'Nunito Sans', sans-serif;

    @media ${devices.tabletPortrait} {
        font-size: 1.6rem;
    }
`;


export const Error = styled.div`
    display: flex;
    align-items: center;
    padding: 12px;
    border: 1px solid #d9534f;
    border-radius: .7rem;
    background-color: rgba(217, 84, 79, .3);

    i {
        svg {
            width: 24px;
            height: 24px;
            color: var(--white);
        }
    }

    span {
        font-size: 1.4rem;
        margin-left: 8px;
    }
`